import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/src/components/Docs/DocsLayout.tsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Feature Flag`}</h1>
    <h2>{`Check feature`}</h2>
    <p>{`Check if a feature is enabled for a user.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`let featureId = "feature-1"

tesfy.isFeatureEnabled(featureId: featureId) // true|false
`}</code></pre>
    <p>{`A `}<inlineCode parentName="p">{`userId`}</inlineCode>{` and `}<inlineCode parentName="p">{`attributes`}</inlineCode>{` could be optionally supplied.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`let featureId = "feature-1"
let userId = "676380e0-7793-44d6-9189-eb5868e17a86"
let attributes = """
  { "countryCode": "us" }
"""

tesfy.isFeatureEnabled(featureId: featureId, userId: userId, attributes: attributes) // true|false
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      